const Constants = [
  // Address
  'ADDRESS_AUTO_COMPLETE',
  'ADDRESS_DETAILS',

  // Properties
  'UPDATE_CURRENT_PROPERTY',
  'UPDATE_CURRENT_PROPERTY_DISPLAY_TOTAL_MONTHLY_PRICE_WITH_FEE',
  'UPDATE_CURRENT_PROPERTY_BUILDING_ATTRIBUTES',
  'UPDATE_CURRENT_PROPERTY_CURRENT_ROOMMATES_DETAILS',
  'UPDATE_CURRENT_PROPERTY_ROOMMATE_REQUIREMENTS',
  'UPDATE_CURRENT_PROPERTY_RENTAL_PROTECTION',
  'UPDATE_CURRENT_PROPERTY_RENTERS_INSURANCE',
  'UPDATE_CURRENT_PROPERTY_CURRENT_PETS',
  'UPDATE_CURRENT_PROPERTY_FREEMIUM',
  'UPDATE_PROPERTIES',
  'UPDATE_PROPERTIES_FILTERS',
  'UPDATE_PROPERTIES_CONVERSION',
  'UPDATE_PROPERTY_OVERVIEW',
  'UPDATE_SUB_NAV_FILTERS_TOUCHED',
  'UPDATE_ACCORDION_STATE',
  'UPDATE_WEB_ANALYTICS',
  'UPDATE_DATE_EMAIL_VERIFIED',
  'UPDATE_RESTRICTIONS',
  'UPDATE_POST_ACTIVATION_STATE',

  // Email Verification
  'UPDATE_EMAIL_VERIFICATION',

  // Paid Inclusion
  'INITIATE_CREDIT_CARD_CAPTURE_FAIL',
  'START_PAYMENT_METHOD_SESSION_SUCCESS',
  'VERIFY_CREDIT_CARD_CAPTURE_SUCCESS',
  'CREDIT_CARD_FORM_LOAD_COMPLETE',
  'CREDIT_CARD_FORM_SUBMITTING',
  'CREDIT_CARD_FORM_SUBMIT_SUCCESS',
  'CREDIT_CARD_FORM_SUBMIT_FAIL',
  'INITIATE_CREDIT_CARD_CHARGE',
  'LISTING_CANNOT_BE_ACTIVATED',
  'CHARGE_AND_ACTIVATE_LISTING_SUCCESS',
  'DEFAULT_PAYMENT_SUCCESS',
  'DEFAULT_PAYMENT_FAIL',
  'RESET_CREDIT_CARD_CAPTURE_POST_PAYMENT',

  // Enterprise single family
  'SINGLE_FAMILY_SET_CONTRACTS',

  // Env
  'SET_ENV',

  // User Management
  'USER_MANAGEMENT_GET_USERS_LOADING',
  'USER_MANAGEMENT_GET_USERS_SUCCESS',
  'USER_MANAGEMENT_GET_USERS_FAIL',
  'USER_MANAGEMENT_UPDATE_USERS_LOADING',
  'USER_MANAGEMENT_UPDATE_USERS_SUCCESS',
  'USER_MANAGEMENT_UPDATE_USERS_FAIL',
  'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_LOADING',
  'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_SUCCESS',
  'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_FAIL',
  'USER_MANAGEMENT_EDITABLE_USER_LOAD',
  'USER_MANAGEMENT_SET_EDITABLE_USER_PERMISSION',
  'USER_MANAGEMENT_SET_EDITABLE_USER_LOADING_STATE',

  // Zillow Subscription
  'ZILLOW_SUBSCRIPTION_GET_SUCCESS',
  'ZILLOW_SUBSCRIPTION_UPDATE_SUCCESS',

  // Rent Guarantee
  'RENT_GUARANTEE_UPDATE_MONTHLY_RENT',
  'RENT_GUARANTEE_UPDATE_PAYMENT_METHOD',
  'RENT_GUARANTEE_UPDATE_SECURITY_DEPOSIT_AMOUNT',
  'RENT_GUARANTEE_UPDATE_IS_SECURITY_DEPOSIT_WAIVED',
  'RENT_GUARANTEE_UPDATE_TENANT_PAYMENT_AMOUNT',
  'RENT_GUARANTEE_UPDATE_LANDLORD_RECRIPT_AMOUNT',
  'RENT_GUARANTEE_UPDATE_IS_ONLINE_TOOLS_ENABLED',
  'RENT_GUARANTEE_UPDATE_IS_INTERESTED',
  'RENT_GUARANTEE_UPDATE_IS_APPLICATIONS_ENABLED',

  'UPDATE_RECOMMENDATIONS',

  // Submit Request Page
  'UPDATE_SELECTED_HELP_CATEGORY',
  'UPDATE_SELECTED_HELP_TOPIC',

  // devTool
  'UPDATE_DEV_TOOL',
  'ADD_DEV_TOOL_API_LIST',
];

const DispatchConstants = Constants.reduce((accumulator: { [key: string]: string }, value) => {
  accumulator[value] = value;
  return accumulator;
}, {});

export default DispatchConstants;
